import type { StepConfig } from "@portal/components/multiform/types";
import type { AdminCombinedFormData } from "../../schema";
import { DetailsStep } from "./DetailsStep";
import { DetailsSummary } from "./DetailsSummary";

export const detailsStepConfig: StepConfig<AdminCombinedFormData> = {
	name: "details",
	label: "Details",
	fieldPaths: ["requiresPaymentAndPerformanceBonds", "account.modelSize", "account.details"],
	component: DetailsStep,
	summaryComponent: DetailsSummary,
};
